import { getOperationName } from '@apollo/client/utilities';

import { InvestorContactSearch_InvestorFirmsEmployeesDocument } from '../contact-search/graphql/__generated__';
import {
  useInvestorContactInformation_AssignContactsMutation,
  useInvestorContactInformation_AssignCoveredContactsMutation,
} from '../graphql/__generated__';

export const useAssignContactsMutation = (isCoveredAccount: boolean) => {
  const assignContactsMutation = useInvestorContactInformation_AssignContactsMutation({
    refetchQueries: [getOperationName(InvestorContactSearch_InvestorFirmsEmployeesDocument)!],
  });
  const assignCoveredContactsMutation = useInvestorContactInformation_AssignCoveredContactsMutation(
    {
      refetchQueries: [getOperationName(InvestorContactSearch_InvestorFirmsEmployeesDocument)!],
    }
  );

  return isCoveredAccount ? assignCoveredContactsMutation : assignContactsMutation;
};
